import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { ConfirmationService, MessageService, MenuItem } from "primeng/api";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "src/app/services/auth.service";
import { UserService } from "src/app/services/user.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { KycService } from "src/app/services/kyc.service";
import { MustMatch } from "src/app/_helpers/must-match.validator";
@Component({
  selector: "app-bank-details",
  templateUrl: "./bank-details.component.html",
  styleUrls: ["./bank-details.component.scss"],
  providers: [ConfirmationService, MessageService, KycService],
})
export class UserBankDetailsComponent implements OnInit {
  showBankModal: boolean = false;
  deleteSheduleModal: boolean = false;
  items: MenuItem[];
  id;
  public loggedInUser;
  public isLoggedIn: boolean;
  public userId;
  public panForm: FormGroup;
  public submitted: boolean;
  public showMessage: boolean = false;
  public isAcademy: boolean = false;
  bankDetails: any = [];
  public bankSubmitted: boolean = false;
  public bankForm: FormGroup;
  errorMessage: any;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private tokenStorage: TokenStorageService,
    private authService: AuthService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private renderer: Renderer2,
    private kycService: KycService,
  ) { }
  async ngOnInit(): Promise<void> {
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.isLoggedIn = true;
      this.userId = this.loggedInUser.userdata.id;
    }
    let roleName = this.loggedInUser.userdata.rolename;
    if (roleName == "academy") {
      this.isAcademy = true;
    }
    if (this.isLoggedIn == false) {
      this.router.navigate(["/"]);
    }
    this.bankForm = this.formBuilder.group(
      {
        bankName: ["", { validators: [Validators.required, Validators.pattern("^[A-Za-z '][A-Za-z ']*$")], updateOn: "blur", },],
        name: ["", { validators: [Validators.required, Validators.pattern("^[A-Za-z '][A-Za-z ']*$")], updateOn: "blur", },],
        mobileNumber: [null, { validators: [Validators.required, Validators.pattern("[0-9 ]{10}")], updateOn: 'blur' }],
        bankAccountNumber: [null, { validators: [Validators.required, Validators.pattern('^[0-9]{9,18}$')], updateOn: "blur", },],
        confirmAccountNumber: ["", { validators: Validators.required, updateOn: "blur", },],
        ifscCode: ["", { validators: [Validators.required, Validators.pattern("^[A-Za-z]{4}0[A-Z0-9a-z]{6}$"),], updateOn: "blur", },],
      }, {
      validator: MustMatch("bankAccountNumber", "confirmAccountNumber"),
    });
    this.id = this.userId;
    this.getBankDetails(this.userId);
    this.renderer.addClass(document.body, 'banklist-page');
  }
  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'banklist-page');
  }
  get f() {
    return this.panForm.controls;
  }
  get bankF() {
    return this.bankForm.controls;
  }
  async getBankDetails(userId) {
    let query = "filterByDisable=false&filterByStatus=true";
    this.kycService.getUserKycBankList(userId, query).subscribe(
      res => {
        this.bankDetails = res?.items;
      },
      err => {
      }
    );
  }
  onSubmitBankForm() {
    this.bankSubmitted = true;
    //stop here if form is invalid
    if (this.bankForm.invalid) {
      return;
    }
    let bankData = this.bankForm.value;
    bankData["isDocumentComplete"] = true;
    bankData["isPrimary"] = false;
    delete bankData["confirmAccountNumber"];
    this.kycService.bankVerification(bankData).subscribe(
      (data) => {
        if (data?.data?.account_exists) {
          this.showMessage = true;
          this.bankSubmitted = false;
          this.showBankModal = false;
          this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Bank Account Added successfully', life: 3000 });
          this.getBankDetails(this.userId);
          this.bankForm.reset();
        } else {
          this.messageService.add({ key: "toastmsg", severity: "error", summary: "Error", detail: data?.data?.message, life: 6000, });

        }
      },
      (err) => {
        this.messageService.add({ key: "toastmsg", severity: "error", summary: "Error", detail: err.error.error, life: 6000, });
      }
    );
  }
  showbankDialog() {
    this.showBankModal = true;
    this.bankForm.reset();
    this.bankSubmitted = false;
  }
  onClickDelete(bank) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this ' + bank.bankAccountNumber + ' bank account?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        var updateData = '{"disable":true}';
        this.kycService.updateBank(bank._id, updateData).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Bank Account Deleted successfully', life: 3000 });
            this.getBankDetails(this.userId);
          },
          err => {
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        this.getBankDetails(this.userId);
      }
    });
  }
  onClickSetPrimary(bank) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to set this ' + bank.bankAccountNumber + ' bank account as primary?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        var updateData = '{"isPrimary":true}';
        this.kycService.updateBank(bank._id, updateData).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Bank Account Set as primary successfully', life: 3000 });
            this.getBankDetails(this.userId);
          },
          err => {
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        this.getBankDetails(this.userId);
      }
    });
  }

  onClickBack() {
    this.router.navigate(['/my-wallet']);
  }
}
